/* Daiko : pastilles de taille des cartes TV — la carte se met à jour sur place, sans ouvrir la fiche produit (comme lg.com) */
(function () {
  if (window.__daikoTvSizeSwitch) return;
  window.__daikoTvSizeSwitch = true;

  document.addEventListener('click', function (event) {
    var chip = event.target.closest('.pcard-tv-size');
    if (!chip || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    var card = chip.closest('.pcard-tv');
    if (!card) return;
    event.preventDefault();
    if (chip.classList.contains('is-current')) return;

    var d = chip.dataset;
    var available = d.available === 'true';
    var oldUrl = card.dataset.tvUrl;

    // Liens (image, titre, En savoir plus)
    card.querySelectorAll('a').forEach(function (a) {
      if (!a.classList.contains('pcard-tv-size') && a.getAttribute('href') === oldUrl) a.setAttribute('href', d.url);
    });
    card.dataset.tvUrl = d.url;

    // Titre + référence
    var title = card.querySelector('.product-card__title .reversed-link__text');
    if (title) title.textContent = d.title;
    var imageLink = card.querySelector('.product-card__image-wrapper > a');
    if (imageLink) imageLink.setAttribute('aria-label', d.title);
    var sku = card.querySelector('.product-card__sku');
    if (sku) sku.textContent = d.sku ? 'Réf : ' + d.sku : '';

    // Image (cadre 180 x 180 + zoom propre à la photo)
    var media = card.querySelector('.product-card__image--main');
    var img = media && media.querySelector('img');
    if (img && d.img) {
      img.srcset = d.srcset;
      img.src = d.img;
      img.alt = d.alt || d.title;
      media.style.setProperty('--pcard-tv-zoom', d.zoom || 1);
    }

    // Prix
    var regular = card.querySelector('.f-price__regular .f-price-item--regular');
    if (regular) regular.textContent = d.price;

    // Badge Épuisé
    var sizes = chip.closest('.pcard-tv-sizes');
    var soldOutLabel = (sizes && sizes.dataset.soldout) || 'Épuisé';
    var badge = card.querySelector('.product-card__badge');
    if (badge) {
      badge.querySelectorAll('.f-badge--soldout').forEach(function (b) { b.remove(); });
      if (!available) {
        var span = document.createElement('span');
        span.className = 'f-badge f-badge--soldout';
        span.setAttribute('aria-hidden', 'true');
        span.textContent = soldOutLabel;
        badge.prepend(span);
      }
    }

    // Bouton Acheter : variante ajoutée au panier + état épuisé
    var idInput = card.querySelector('.pcard-tv-form input[name="id"]');
    var button = card.querySelector('.pcard-tv-form button[name="add"]');
    if (idInput) {
      idInput.value = d.variant;
      idInput.disabled = !available;
    }
    if (button) {
      button.disabled = !available;
      var text = button.querySelector('.btn__text');
      if (text) {
        text.innerHTML = available
          ? '<span class="pcard-tv-buy__long">Acheter maintenant</span><span class="pcard-tv-buy__short">Acheter</span>'
          : '';
        if (!available) text.textContent = soldOutLabel;
      }
    }

    // Case Comparer
    var compare = card.querySelector('.js-compare-checkbox');
    if (compare) {
      if (compare.checked) {
        compare.checked = false;
        compare.dispatchEvent(new Event('change', { bubbles: true }));
      }
      compare.dataset.productId = d.id;
      compare.dataset.productUrl = d.url;
    }

    // Pastille active
    sizes.querySelectorAll('.pcard-tv-size').forEach(function (c) {
      c.classList.remove('is-current');
      c.removeAttribute('aria-current');
    });
    chip.classList.add('is-current');
    chip.setAttribute('aria-current', 'true');
  });
})();
